import React from 'react';
import PropTypes from 'prop-types';
import Message from '../../../../common/Message';
import MotiveTitle from '../../../../views/Contact/Motive/MotiveTitle';
import { textMapper } from '../../../../../helpers/FormHelper';

const Form = ({ ...props }) => {
  const { mobile, motiveId } = props;

  return (
    <React.Fragment>
      {mobile && (
        <React.Fragment>
          <MotiveTitle
            icon={textMapper.get(motiveId).icon}
            title={textMapper.get(motiveId).title}
            subtitle={textMapper.get(motiveId).subtitle}
            mobile={mobile}
          />
        </React.Fragment>
      )}

      <Message
        severity="info"
        message="Para consultar el saldo de tu Gift Card deberás hacerlo a traves de Mi Cuenta"
      />
    </React.Fragment>
  );
};

Form.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
};

export default Form;
